import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { PagesPage } from '@/features/content/PagesPage';

export interface PagesSearch {
  /** Открытая форма: `new` — создание, идентификатор — правка. */
  edit?: string;
}

/** Контентные страницы ([B-CNT-52]): «О компании», «Доставка и оплата», «Контакты», FAQ и свободные. */
export const Route = createFileRoute('/_app/pages')({
  validateSearch: (search: Record<string, unknown>): PagesSearch => ({
    edit: typeof search.edit === 'string' && search.edit !== '' ? search.edit : undefined,
  }),
  component: PagesRoute,
});

function PagesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const onEditingChange = useCallback(
    (edit: string | null) => {
      void navigate({ search: (previous) => ({ ...previous, edit: edit ?? undefined }), replace: false });
    },
    [navigate],
  );

  return <PagesPage editing={search.edit ?? null} onEditingChange={onEditingChange} />;
}
